export type YearSelectOption = {
  label: string;
  value: string;
};

/**
 * Year dropdown options for month/day/year pickers.
 * Always includes `includeYear` when it is a valid year, even if it falls
 * outside min/max, so existing saved dates still display and can be saved.
 */
export function buildYearSelectOptions({
  minYear,
  maxYear,
  order = "asc",
  includeYear,
}: {
  minYear: number;
  maxYear: number;
  order?: "asc" | "desc";
  includeYear?: string | number | null;
}): YearSelectOption[] {
  const lo = Math.min(minYear, maxYear);
  const hi = Math.max(minYear, maxYear);
  const years = new Set<number>();
  for (let year = lo; year <= hi; year += 1) {
    years.add(year);
  }

  const extra =
    includeYear == null || includeYear === "" ? Number.NaN : Number(includeYear);
  if (Number.isFinite(extra)) {
    years.add(Math.trunc(extra));
  }

  const sorted = [...years].sort((a, b) => (order === "desc" ? b - a : a - b));
  return sorted.map((year) => ({
    label: String(year),
    value: String(year),
  }));
}
